<template>
  <div class="container-xl mt-3">
    <div class="card w-100 shadow">
      <div class="card-header text-center scroll">
        <ul class="nav nav-tabs card-header-tabs">
          <li
            class="nav-item"
            v-for="(item, index) in headers"
            :key="item.contentId"
            :style="`padding: 0; min-width: ${item.width} !important;`"
            :id="item.contentId"
            v-on:click="changeHeader(item.contentId, index)"
          >
            <div :class="`nav-link link ${active === item.contentId ? 'active shadow' : ''}`">
              <progressBar
                :progress="item.progress ? item.progress : 0"
                :danger="active === item.contentId ? greenBar : grayBar"
                :warning="active === item.contentId ? greenBar : grayBar"
                :success="active === item.contentId ? greenBar : grayBar"
                class="mt-1 mb-3"
              />
              <span :class="active === item.contentId ? 'text-primary' : ''">{{ item.title }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="float-right p-2">
          <a class="nav-link link">
            <i v-if="!hidden" @click.prevent="hiddenComponent(!hidden)" class="fa fa-window-minimize fa-lg text-info" aria-hidden="true"></i>
            <i v-if="hidden" @click.prevent="hiddenComponent(!hidden)" class="fa fa-window-maximize fa-lg text-info" aria-hidden="true"></i>
          </a>
        </div>
        <component v-if="!hidden" v-bind:is="active" :progressName="active"></component>
      </div>
    </div>
    <div class="row btnAcoes mt-3">
      <button class="btn btn-outline-success" @click.prevent="pesquisar()"> Pesquisar </button>
      <button class="btn btn-outline-danger" @click.prevent="limpar"> Limpar </button>
    </div>
  </div>
</template>

<script>
import progressBar from '@/components/progressBar/ProgressBar'
import filtroProtocolo from '@/components/buscaGeral/filtros/Protocolo'
import filtroEstrutura from '@/components/buscaGeral/filtros/Estrutura'
import filtroInteressado from '@/components/buscaGeral/filtros/Interessado'

import { mapState } from 'vuex'

import VirtusService from '@/services/VirtusService'
import eventBus from '@/uteis/eventBus'

export default {
  props: {
    rowsNumber: { required: true, type: Number },
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String }
  },

  components: {
    progressBar,
    'filtro-protocolo': filtroProtocolo,
    'filtro-estrutura': filtroEstrutura,
    'filtro-interessado': filtroInteressado
  },

  data () {
    return {
      hidden: false,
      active: 'filtro-protocolo',
      headerIndex: 0,
      greenBar: 'bg-success',
      grayBar: 'bg-secondary',
      headers: [{
        title: 'Protocolo',
        contentId: 'filtro-protocolo',
        width: '200px',
        progress: 0
      }, {
        title: 'Interessado',
        contentId: 'filtro-interessado',
        width: '200px',
        progress: 0
      }]
    }
  },

  created () {
    this.service = new VirtusService()

    eventBus.$on(this.eventBusPaginationName, (numeroPagina) => {
      this.pesquisar(numeroPagina)
    })
    this.pesquisar()
  },

  methods: {
    changeHeader (contentId, index) {
      this.active = contentId
      this.headerIndex = index
    },

    pesquisar (page = 1) {
      this.service.consultaGeral({
        ...this.filtro,
        offset: page,
        range: this.rowsNumber,
        ignoreAtivo: true
      }).then((resp) => {
        eventBus.$emit(this.eventBusDataName, resp)
      })
    },

    hiddenComponent (hidden) {
      this.hidden = hidden
    },

    limpar () {
      this.$store.commit('MUT_LIMPAR_FILTRO_PESQUISA_GERAL')
      this.pesquisar(1)
    }
  },

  computed: mapState({
    filtro: state => state.filtroGeral,
    progress: state => state.progressFiltroGeral,
    change: state => state.progressFiltroGeral.change
  }),

  watch: {
    change (newValue) {
      var length = Object.keys(this.progress).length
      if (length !== 1) {
        this.headers[this.headerIndex].progress = Number(this.progress[this.active])
        return
      }

      for (var i = 0; i < this.headers.length; i++) {
        this.headers[i].progress = 0
      }
    }
  },

  destroyed () {
    eventBus.$off(this.eventBusPaginationName)
  }
}
</script>
